import { useLocalStorage } from "@medoma/shared-employee/useLocalStorage";
import { useUserProfile } from "@/api/Users";
import { z } from "zod";

export const activeSidePanelsSchema = z.enum(["aiSupportPanel"]);
const emptySidePanelSchema = z.literal("");
const sidePanelSchema = z.union([activeSidePanelsSchema, emptySidePanelSchema]);
export type IActiveSidePanel = z.infer<typeof activeSidePanelsSchema>;

export const useSidePanel = () => {
  const { userId } = useUserProfile();
  const [activeSidePanel, setActiveSidePanel] = useLocalStorage({
    key: "sidePanel.active",
    userId,
    initialValue: emptySidePanelSchema.value,
  });

  const safeParsedActiveSidePanel = sidePanelSchema.safeParse(activeSidePanel);

  const parsedActiveSidePanel = safeParsedActiveSidePanel.success
    ? safeParsedActiveSidePanel.data
    : emptySidePanelSchema.value;

  const showSidePanel = parsedActiveSidePanel !== emptySidePanelSchema.value;

  function toggleSidePanel(panel: IActiveSidePanel) {
    if (parsedActiveSidePanel === panel) {
      setActiveSidePanel(emptySidePanelSchema.value);
    } else {
      setActiveSidePanel(panel);
    }
  }

  function closeSidePanel() {
    setActiveSidePanel(emptySidePanelSchema.value);
  }

  return {
    showSidePanel,
    activeSidePanel: parsedActiveSidePanel,
    setActiveSidePanel,
    toggleSidePanel,
    closeSidePanel,
  } as const;
};
